import { styled } from "@styles";

export const Container = styled("div", {
  textDecoration: "none",
  width: "100%",
  height: "fit-content",

  u: {
    textDecoration: "underline",
  },
  ul: {
    listStyle: "initial",
    marginLeft: "30px",
  },
});
